__turbopack_context__.v({
  "wrapper": "style-module-scss-module__WzKZ7a__wrapper",
});
